import { environment } from '../../environments/environment';
import { ProjectStatus } from '@shared/interfaces/project/project-status.interface';
import { Continents } from '@shared/interfaces/project/continents.interface';
import { MetTags } from '@shared/interfaces/meta-tags.interface';
import * as Leaflet from 'leaflet';

export class Config {
  static DEBUG: boolean = !environment.production;
  static HOST: string = environment.host;
  static API_URL: string = Config.HOST + '/api';
  static CLIENT_HOST: string = environment.client;
  static DEFAULT_AVATAR_SIZE: string = '44';

  static GOOGLE_APP_ID: string =
    '169226974137-1r92ic6bjhju07dptmvph5vp75rs2f1e.apps.googleusercontent.com';
  static GOOGLE_MAPS_NO_CUSTOMIZATION_ID: string = 'e110f5c0a5f386bc';
  static DATE_FORMAT_FRONTEND_SHORT: string = 'DD MMM YYYY';
  static DATE_FORMAT_FRONTEND: string = 'DD MMMM YYYY';
  static DATE_FORMAT_FRONTEND_FULL: string = 'DD MMMM YYYY, HH:mm';
  static DATE_FORMAT_FRONTEND_TIME_ONLY: string = 'HH:mm';
  static DATE_FORMAT_BACKEND: string = 'YYYY-MM-DD HH:mm:ss Z';
  static UPLOAD_SIZE: number = 5242880; // 5 MB
  static UPLOAD_SIZE_DOCUMENT: number = 7340032; // 7 MB
  static UPLOAD_SIZE_AVATAR: number = 5242880; // 5 MB
  static MINIMAL_PAY_COUNT: number = 1;
  static MAXIMAL_PAY_COUNT: number = 2500;
  static CURRENCY_TEXT: string = 'USD';
  static PROJECT_STATUS: ProjectStatus[] = [
    { color: 'grey', name: 'ended' },
    { color: 'fiolet', name: 'draft' },
    { color: 'green', name: 'verified' },
    { color: 'gold', name: 'in_review' },
  ];
  static EVENT_STATUS: ProjectStatus[] = [
    { color: 'fiolet', name: 1 },
    { color: 'green', name: 2 },
    { color: 'grey', name: 3 },
    { color: 'grey', name: 4 },
  ];
  static PROJECT_CHART_TYPE: string = 'line';
  static PROJECT_BAR_SCROLL_OFFSET: number = 86;
  static CONTINENTS: Continents[] = [
    { name: 'Europa', value: 'EU' },
    { name: 'Africa', value: 'AF' },
    { name: 'South America', value: 'SA' },
    { name: 'North America', value: 'NA' },
    { name: 'Asia', value: 'AS' },
    { name: 'Oceania', value: 'OC' },
  ];
  static PHOTO_ERROR_NO_META: string = 'no-meta';
  static PHOTO_ERROR_NO_GPS: string = 'no-gps';
  static PHOTO_ERROR_WAS_MODIFIED: string = 'modified';
  static PER_PAGE_DEFAULT: number = 16;
  static PROJECT_PER_PAGE_DEFAULT: number = 32;
  static MAXIMAL_ECOHEROES_PARTICIPANT_COUNT: number = 10;
  static LOAD_MORE_PER_PAGE: number = 48;
  static PUBLIC_SHARE_DEFAULT_IMAGE: string =
    'https://planetheroes.pl/assets/img/planet_heroes.webp';
  static DEFAULT_META_TAGS: MetTags = {
    title: 'Planet Heroes - The first eco crowdfunding platform',
    description:
      'First eco-crowdfunding platform that connects people who clean-up the Earth and enables others to send them donations. Global, free and user-friendly. Click and see how you can help the Earth and become a #PlanetHero',
    'og:title': 'Planet Heroes - The first eco crowdfunding platform',
    'og:description': 'Pick up the trash and get extra cash',
    'og:url': 'https://planetheroes.pl',
    'og:image': 'https://planetheroes.pl/assets/img/planet_heroes.webp',
    'twitter:title': 'Planet Heroes - The first eco crowdfunding platform',
    'twitter:description': 'Pick up the trash and get extra cash',
    'twitter:image': 'https://planetheroes.pl/assets/img/planet_heroes.webp',
  };
  static MOBILE_MENU_OPEN_HTML_CLASSES: string =
    'overflow: hidden; position: relative; height: 100%;';
  static MOBILE_MENU_OPEN_BODY_CLASSES: string = 'position: relative; height: 100%;';
  static TPAY_CONTRACT_TERMS: string =
    'https://tpay.com/user/assets/files_for_download/general-terms-and-conditions-of-payment-services.pdf';
  static PAYPAL_TERMS: string = 'https://www.paypal.com/webapps/mpp/ua/legalhub-full';
  static NOTIFICATION_TYPE_USER: string[] = ['project_receive_comment'];
  static NOTIFICATION_TYPE_ACHIEVEMENT: string[] = [
    'active_donor',
    'volunteer',
    'hero',
    'patron',
    'trash_sorter',
  ];
  static NOTIFICATION_TYPE_PROJECT: string[] = [
    'project_was_accepted',
    'project_was_decline',
    'project_was_donated',
    'declined',
  ];
  static WCD_FONT_NAME = 'Chau Philomene One';
  static WALLET_MIN_PAYMENT_WITHDROW_VALUE_TPAY: number = 2000;
  static WALLET_MIN_PAYMENT_WITHDROW_VALUE_PAYPAL: number = 0;
  static RECAPTCHA_SITE_KEY: string = '6Ldlh7kUAAAAAMpcwovGu9qyyVtwsrutnRVYaiUu';
  static SOCIAL_LINK_INSTAGRAM: string = 'https://www.instagram.com/planetheroes.foundation/';
  static SOCIAL_LINK_FACEBOOK: string = 'https://www.facebook.com/PlanetHeroesApp';
  static SOCIAL_SITES: object = {
    facebook: {
      urls: ['facebook.com', 'fb.com'],
    },
    instagram: {
      urls: ['instagram.com'],
    },
    linkedin: {
      urls: ['linkedin.com'],
    },
    twitter: {
      urls: ['twitter.com'],
    },
    tiktok: {
      urls: ['tiktok.com'],
    },
    youtube: {
      urls: ['youtube.com'],
    },
  };
  static HEROTOHERO_LINK_INSTAGRAM: string = 'https://www.instagram.com/herotohero_planetheroes/';
  static HEROTOHERO_LINK_FACEBOOK: string = 'https://www.facebook.com/herotohero.planetheroes';

  static URL_WITHOUT_AUTHORIZATION: string[] = [
    'project',
    'noauth/parameters/projects/random-pictrues',
  ];
  static ECOHEROES_CATEGORY: string = '29';
  static WCD: string = '28';
  // 16,17,18,19,20,21,22,23,24,26,27,28,29 use only specific id there to get Ukrainian event colors, not all of them (collision)
  //                  |
  //                  V
  static UKRAINE_CATEGORY: string = '30';
  static BACKBASE_CATEGORY: string = '41';
  static WITHOUT_UKRAINE_CATEGORY: string = '16,17,18,19,20,21,22,23,24,26,27,28,29';
  static MARKER_ICONS = {
    ambassador: {
      url: './assets/img/icons/map_pin_ambassadors.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    event: {
      url: './assets/img/icons/map_pin_events.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    project: {
      url: './assets/img/icons/map_pin_projects.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    ukraine: {
      url: './assets/img/icons/map_pin_ukraine.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    wcdEvent: {
      url: './assets/img/icons/map_pin_wcd_event.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    wcdProject: {
      url: './assets/img/icons/map_pin_wcd_project.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    backbaseEvent: {
      url: './assets/img/icons/map_pin_wcd_event.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
    backbaseProject: {
      url: './assets/img/icons/map_pin_wcd_project.svg',
      scaledSize: {
        width: 30,
        height: 40,
      },
    },
  };
  static MAP_STYLES = [
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#85858c',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-79',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#e5e8e7',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.natural',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#f5f5f2',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry',
      stylers: [
        {
          hue: '#4dff00',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#f2f5fb',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.government',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'all',
      stylers: [
        {
          gamma: 1.51,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#85858c',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.place_of_worship',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c7c7c7',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.icon',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#a0d3d3',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          hue: '#007bff',
        },
        {
          gamma: '2.84',
        },
      ],
    },
  ];

  static HELP_UKRAINE_MAP_STYLES = [
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#85858c',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-79',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#e5e8e7',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.natural',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#f5f5f2',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry',
      stylers: [
        {
          hue: '#4dff00',
        },
      ],
    },
    {
      featureType: 'landscape.natural.landcover',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#f2f5fb',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.business',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.government',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'all',
      stylers: [
        {
          gamma: 1.51,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#85858c',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.place_of_worship',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c7c7c7',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#c4c4c4',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.icon',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'all',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#a0d3d3',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          hue: '#007bff',
        },
        {
          gamma: '2.84',
        },
      ],
    },
  ];
  static GOOGLE_MAPS_BLUE_STYLE = [
    {
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.country",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#5db1e9"
        },
        {
          "weight": 1.5
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#dff2ff"
        },
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.stroke",
      "stylers": [
        {
          "color": "#5db1e9"
        },
        {
          "weight": 1.5
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    }
  ];
  static MAP_CENTRE_POINT = {
    lat: 47.576526,
    lng: 12.206376
  };
  static LANDING_PAGE_MAP_CENTRE_POINT = {
    lat: 51.9189046,
    lng: 19.1343786
  }
  // Getter, not a shared array: a Leaflet layer can live on only one map at a
  // time, so pages with several maps (e.g. McD "Zgłoś Akcję", dashboard cards)
  // need a fresh TileLayer per map or all but the last lose their tiles.
  static get OPEN_STREET_MAP_LAYERS(): Leaflet.Layer[] {
    return [
      new Leaflet.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      } as Leaflet.TileLayerOptions)
    ] as Leaflet.Layer[];
  }
}
